import getPerformanceBoardsRef from './getPerformanceBoardsRef';
import getReportScheduleRunsRef from './getReportScheduleRunsRef';
import getReportSchedulesRef from './getReportSchedulesRef';
import getReportsRef from './getReportsRef';
import getTargetsApps from './getTargetsApps';
import getEntityDetailsApps from './getEntityDetailsApps';
import getExecutivePortalsRef from './getExecutivePortalsRef';
import getEngagementPortalsRef from './getEngagementPortalsRef';
import getGeneralAppsRef from './getGeneralAppsRef';
import getBonusAppsRef from './getBonusAppsRef';
import getLegacyBonusAppsRef from './getLegacyBonusAppsRef';
import getWorkspacesRef from './getWorkspacesRef';
import getProductsRef from './getProductsRef';

const contentDistributions = {
  getPerformanceBoardsRef,
  getReportScheduleRunsRef,
  getReportSchedulesRef,
  getReportsRef,
  getTargetsApps,
  getEntityDetailsApps,
  getExecutivePortalsRef,
  getEngagementPortalsRef,
  getGeneralAppsRef,
  getBonusAppsRef,
  getLegacyBonusAppsRef,
  getWorkspacesRef,
  getProductsRef,
};

export default contentDistributions;
